import { throwApiError } from '@/shared/utils/apiResponse';
import { apiGet, apiPost } from '@/shared/utils/requestBuilder';
import {
  CertificadoCompleto,
  GerarCertificadoPdfResponse,
  RenderUrlPdfRequest,
  RenderUrlPdfResponse,
} from '../types';

const BASE_URL = '/extrajudicial/certificados';

export const certificadoService = {
  async getByItemId(itemId: string): Promise<CertificadoCompleto> {
    const response = await apiGet(`${BASE_URL}/item/${itemId}`);
    if (!response.ok) {
      await throwApiError(response, 'Erro ao buscar certificado');
    }
    return response.json();
  },

  async getByMessageId(messageId: string): Promise<CertificadoCompleto> {
    const response = await apiGet(`${BASE_URL}/message/${messageId}`);
    if (!response.ok) {
      await throwApiError(response, 'Erro ao buscar certificado');
    }
    return response.json();
  },

  async gerarPdfServerSide(itemId: string): Promise<GerarCertificadoPdfResponse> {
    const response = await apiPost(`${BASE_URL}/item/${itemId}/gerar-pdf`, {});
    if (!response.ok) {
      await throwApiError(response, 'Erro ao gerar PDF do certificado');
    }
    const result = (await response.json()) as {
      success: boolean;
      data: GerarCertificadoPdfResponse;
    };
    if (!result.success) {
      throw new Error('Falha ao gerar PDF do certificado');
    }
    return result.data;
  },

  async renderUrlPdf(payload: RenderUrlPdfRequest): Promise<RenderUrlPdfResponse> {
    const response = await apiPost('/api/pdf/renderUrlPdf', payload, true);

    const data = (await response.json().catch(() => null)) as unknown;

    if (!response.ok) {
      const message =
        data &&
        typeof data === 'object' &&
        'errorMessage' in data &&
        typeof (data as { errorMessage?: unknown }).errorMessage === 'string'
          ? (data as { errorMessage: string }).errorMessage
          : 'Falha ao gerar PDF';
      throw new Error(message);
    }

    if (!data || typeof data !== 'object') {
      throw new Error('Resposta inválida ao gerar PDF');
    }

    const parsed = data as RenderUrlPdfResponse;
    if (!parsed.success || !parsed.resultUrl) {
      throw new Error(parsed.errorMessage || 'Falha ao gerar PDF');
    }

    return parsed;
  },
};
